var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { isProductionEnvironment } from '../utils/environmentVariables';
export var TestIds;
(function (TestIds) {
    TestIds["item"] = "accordion__item";
})(TestIds || (TestIds = {}));
var NONE = -1;
var Wrapper = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var AccordionItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  border-bottom: 1px solid ", ";\n\n  &:first-child {\n    border-top: 1px solid ", ";\n  }\n"], ["\n  list-style: none;\n  border-bottom: 1px solid ", ";\n\n  &:first-child {\n    border-top: 1px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.greyNormal.color.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.greyNormal.color.normal;
});
export var Accordion = function (_a) {
    var _b = _a.layout, layout = _b === void 0 ? 'default' : _b, children = _a.children;
    // Get initially open child
    var initiallyOpenChildren = React.Children.map(children, function (child) {
        if (child.props.initialIsOpen) {
            return child.props.id;
        }
        return null;
    });
    // Avoid multiple open children
    if (!isProductionEnvironment()) {
        if (initiallyOpenChildren.length > 1) {
            throw new Error('Only one child component can be open initially in an Accordion. If you want to open multiple children at the same time, you should implement a new component instead.');
        }
    }
    var _c = useState(initiallyOpenChildren.length > 0 ? initiallyOpenChildren[0] : NONE), idOpenItem = _c[0], setIdOpenItem = _c[1];
    function onToggle(id) {
        if (idOpenItem === id) {
            // Is open, should be closed
            setIdOpenItem(NONE);
        }
        else {
            // Is closed, should be opened
            setIdOpenItem(id);
        }
    }
    return (React.createElement(Wrapper, null, React.Children.map(children, function (child) {
        if (!isProductionEnvironment()) {
            // Avoid missing ID prop
            if (child.props.id === undefined) {
                throw new Error('The Accordion component requires a unique ID prop on every child component to safely identify a specific component. This can be an array index if you know it is stable.');
            }
        }
        return (React.createElement(AccordionItem, { "data-testid": TestIds.item + "-" + child.props.id, key: child.props.id }, React.cloneElement(child, __assign(__assign({}, child.props), { isOpen: idOpenItem === child.props.id, onToggle: function () { return onToggle(child.props.id); }, layout: layout }))));
    })));
};
export default Accordion;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map